module.exports = __webpack_public_path__ + "media/images/top/rank2_bg-b80fd349820d557ad1976f45a221c88a.gif";